/**
 * Run state that belongs to ONE node's in-flight work and must never travel
 * with a copy of it (paste, duplicate). A copied `isProcessing` renders a
 * spinner nothing will ever clear; a copied `jobId`/`jobStatus` points at a
 * job that belongs to the original.
 *
 * Results (`pages`, `imageUrl`, `output`...) are deliberately NOT stripped:
 * copying a node's result is what copy/duplicate is for.
 */
export const RUN_STATE_KEYS = [
  'isProcessing',
  'isGenerating',
  'streamingInProgress',
  'batchProgress',
  'batchCancelRequested',
  'isCondensing',
  'isUploading',
  'uploadFailed',
  'jobId',
  'jobStatus',
  'error',
] as const;

export function stripRunState<T extends Record<string, unknown>>(data: T | undefined): T {
  const out = { ...(data || {}) } as Record<string, unknown>;
  for (const key of RUN_STATE_KEYS) delete out[key];
  return out as T;
}
